import { Card, Col, Row, Typography } from 'antd';
import { BsPeopleFill } from 'react-icons/bs';
import "./dashboard.css";
import { AiFillCheckCircle,  } from 'react-icons/ai';
import { MdOutlineSignalCellularAlt, MdOutlineSort } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchStatistics } from '../../redux/actions/StatisticGeneralActions';
const Accueil = () => {

  const dispatch = useDispatch();
    const data = useSelector((state) => state.statisticsGeneral);
    const statisticGeneral = data?.statistics?.stats || [];

    useEffect(() => {
      dispatch(fetchStatistics());
    }, [dispatch])


return (
            <Row gutter={[30, 30]}>
                    <Col span={12}>
                        <Card className="statisticClasnam" >
                        <Row gutter={4} style={{ marginBottom: "-12px" }}>
                            <Col span={24}>
                            <MdOutlineSort  className="iconCards1" />
                            </Col>
                            <Col span={24}><Typography.Title level={4} className="titre">Nombre de formulaires</Typography.Title></Col>
                            <Col span={24}>
                            <Typography.Title level={2} className="nombre" >
                                {statisticGeneral.totalForms}
                            </Typography.Title>
                            </Col>
                        </Row>
                        </Card>
                    </Col>

                        <Col span={12}>
                            <Card className="statisticClasnam">
                            <Row gutter={4} style={{ marginBottom: "-12px" }}>
                                <Col span={24}>
                                    <MdOutlineSignalCellularAlt  className="iconCards" />
                                </Col>
                                <Col span={24}>
                                    <Typography.Title level={4} className="titre">Réponses totales</Typography.Title>
                                </Col>
                                <Col span={24}>
                                    <Typography.Title className="nombre" level={2}>
                                        {statisticGeneral.totalResponses}
                                    </Typography.Title>
                                </Col>
                            </Row>
                            </Card>
                        </Col>

                    <Col span={12}>
                        <Card className="statisticClasnam" >
                        <Row gutter={4} style={{ marginBottom: "-12px" }}>
                            <Col span={24}>
                           <AiFillCheckCircle  className="iconCards" />
                            </Col>
                            <Col span={24}><Typography.Title level={4} className="titre">Réponses aujourd'hui</Typography.Title></Col>
                            <Col span={24}>
                            <Typography.Title level={2} className="nombre" >
                                {statisticGeneral.recentResponses}
                            </Typography.Title>
                            </Col>
                        </Row>
                        </Card>
                    </Col>

                        <Col span={12}>
                            <Card className="statisticClasnam">
                            <Row gutter={4} style={{ marginBottom: "-12px" }}>
                                <Col span={24}>
                                    <BsPeopleFill  className="iconCards" />
                                </Col>
                                <Col span={24}>
                                    <Typography.Title level={4} className="titre">Utilisateurs</Typography.Title>
                                </Col>
                                <Col span={24}>
                                    <Typography.Title className="nombre" level={2}>
                                        {statisticGeneral.totalUsers}
                                    </Typography.Title>
                                </Col>
                            </Row>
                            </Card>
                        </Col>
            </Row>
    ); 
};

export default Accueil;